import { createReducer } from '@reduxjs/toolkit'
import { TetrisDefaultPrice } from 'interfaces/api/tetrisDefaultPrices.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllTetrisDefaultPrices, updateTetrisDefaultPrice } from './actions'

interface TetrisDefaultPricesState {
  list: {
    loading: boolean
    items: TetrisDefaultPrice[]
    loadingUpdate: boolean
  }
}

const initialState: TetrisDefaultPricesState = {
  list: {
    loading: false,
    items: [],
    loadingUpdate: false,
  },
}

export const tetrisDefaultPricesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllTetrisDefaultPrices.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllTetrisDefaultPrices.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllTetrisDefaultPrices.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(updateTetrisDefaultPrice.pending, (state) => {
      state.list.loadingUpdate = true
    })
    .addCase(updateTetrisDefaultPrice.rejected, (state) => {
      state.list.loadingUpdate = false
    })
    .addCase(updateTetrisDefaultPrice.fulfilled, (state) => {
      state.list.loadingUpdate = false
    })
})
